/** @jsxImportSource @emotion/react */
import * as React from 'react';
import { css, SerializedStyles } from '@emotion/react';
import { HistoricalRedemption } from './historicalRedemption';
import { BLACK, COOL_GREY, LIGHT_GREY } from '../../../styles/colors';
import { RedemptionHistory } from './RedemptionHistory';
import StatSummary from '../../../layout/StatSummary';
import Tooltip from '../../../layout/tooltip/Tooltip';
import { getResource } from '../../../language/resources/getResource';
import { IAppState } from '../../../core/redux/IAppState';
import { useSelector } from 'react-redux';


const HorizontalTable = css`
  background-color: ${LIGHT_GREY};
  border: 1px solid ${COOL_GREY};
  padding: 10px;
`;


interface Props {
  totalDays: number | string,
  daysUsed: number | string,
  remainingDaysAvailable: number | string,
  redemptionHistory?: HistoricalRedemption[],
  disableTooltip?: boolean,
  rootCss?: SerializedStyles,
}

/**
 * A component that shows Redemption information on Total Days, Days Used, and Days Available in a horizontal format
 * @param totalDaysAvailable - Days available
 * @param daysUsed - Days used
 * @param remainingDaysAvailable - Remaining days available
 * @param redemptionDateHistory - set of redemption dates for prior usage
 * @param disableTooltip - determines whether or not to use the tooltip on Days Used
 * @param css -- CSS class to apply to the component root
 */
export const RedemptionDetails: React.FC<Props> = (
  {
    totalDays,
    daysUsed,
    remainingDaysAvailable,
    redemptionHistory,
    disableTooltip,
    rootCss: rdCss,
  },
) => {
  const [hideTooltip] = React.useState(false);
  const resources = useSelector((state: IAppState) => state.locale);

  return (
  <div  css={css`display: flex;
                      justify-content: space-around;
                      align-items: baseline;
                      ${HorizontalTable};
                      ${rdCss};
  `}>
    <StatSummary label={getResource(resources, 'REDEMPTION_STATS_TOTAL_DAYS')} value={totalDays}/>
    <StatSummary label={getResource(resources, 'REDEMPTION_STATS_DAYS_AVAILABLE')} value={remainingDaysAvailable} />
    {
      disableTooltip
        ? <StatSummary label={getResource(resources, 'REDEMPTION_STATS_DAYS_USED')} value={daysUsed}/>
        : <Tooltip side="top"
                   tooltipContent={
                     <RedemptionHistory history={redemptionHistory}
                                        className={css`background-color: ${BLACK}; padding: 10px 0;`}/>
                   }
                   disable={hideTooltip}
                   children={<StatSummary label={getResource(resources, 'REDEMPTION_STATS_DAYS_USED')} value={daysUsed} />}/>
    }
  </div>
)};

